import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { Col, Container, Row } from 'react-bootstrap'

import Layout from '@shared/components/layout'
import { pageLoading } from '@shared/libs/allLoader'
import usePlayerCompare from '@shared/hooks/usePlayerCompare'

const PopularPlayers = dynamic(() => import('@shared/components/player/popularPlayers'))
const ComparePlayerInfo = dynamic(() => import('@shared/components/player/comparePlayerInfo'), { loading: () => pageLoading() })
const ComparePlayerStats = dynamic(() => import('@shared/components/player/comparePlayerStats'), { loading: () => pageLoading() })
const Ads = dynamic(() => import('@shared/components/ads'))

function PlayerCompare({ p1Seo, p2Seo, p1Detail, p2Detail, widgetData }) {
  const { seoData, firstPlayer, secondPlayer, playerInfo } = usePlayerCompare({ p1Seo, p2Seo, p1Detail, p2Detail })
  return (
    <Layout data={{ oSeo: seoData }}>
      <main className="my-3 my-md-4">
        <Container>
          <Row>
            <Col lg={9} className="left-content">
              <ComparePlayerInfo playerInfo={playerInfo} firstPlayer={firstPlayer} secondPlayer={secondPlayer} />
              {(firstPlayer || secondPlayer) && <ComparePlayerStats firstPlayer={firstPlayer} secondPlayer={secondPlayer} />}
            </Col>
            <Col lg={3} className="common-sidebar d-none d-lg-block">
              <PopularPlayers popularPlayers={widgetData?.popularPlayer} />
              {/* <CurrentSeries /> */}
              <Ads
                id="div-ad-gpt-138639789-1716301699-6"
                adIdDesktop="Crictracker_New_Desktop_SP_RightMID_300x600"
                slotId="23148549803"
                dimensionDesktop={[300, 600]}
                className="sticky-ads position-sticky mb-2"
              />
            </Col>
          </Row>
        </Container>
      </main>
    </Layout>
  )
}
PlayerCompare.propTypes = {
  p1Seo: PropTypes.object,
  p2Seo: PropTypes.object,
  p1Detail: PropTypes.object,
  p2Detail: PropTypes.object,
  widgetData: PropTypes.object
}
export default PlayerCompare
export async function getServerSideProps({ req, res, params, query, resolvedUrl }) {
  const [graphql, articleQuery, utils, playerQuery] = await Promise.all([
    import('@shared-components/queryGraphql'),
    import('@graphql/article/article.query'),
    import('@shared/utils'),
    import('@graphql/players/players.query')
  ])
  const slug = params?.slug?.split('-vs-')
  try {
    const api = [graphql.default(articleQuery.GET_ARTICLE_ID, { input: { sSlug: `cricket-players/${slug[0]}` } })]
    if (slug?.length > 1 && slug[1]) {
      api.push(graphql.default(articleQuery.GET_ARTICLE_ID, { input: { sSlug: `cricket-players/${slug[1]}` } }))
    }
    const [p1Seo, p2Seo] = await Promise.all(api)
    const seoP1 = p1Seo?.data?.getSeoData || {}
    const seoP2 = p2Seo?.data?.getSeoData || {}

    const playerApi = [
      graphql.default(playerQuery.GET_POPULAR_PLAYER, { input: { nLimit: 5 } }),
      graphql.default(playerQuery.GET_PLAYERS, { input: { _id: seoP1?.iId } })
    ]
    if (seoP2?.iId) playerApi.push(graphql.default(playerQuery.GET_PLAYERS, { input: { _id: seoP2?.iId } }))

    const [popularPlayer, p1Detail, p2Detail] = await Promise.allSettled(playerApi)
    res.setHeader('Cache-Control', 'public, max-age=86400')

    return {
      props: {
        p1Seo: seoP1,
        p2Seo: seoP2,
        p1Detail: p1Detail?.value?.data?.getPlayerByIdFront || {},
        p2Detail: p2Detail?.value?.data?.getPlayerByIdFront || {},
        widgetData: {
          popularPlayer: popularPlayer?.value?.data?.getPopularPlayers || []
        }
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = utils.handleApiError(e, resolvedUrl)
    return status
  }
}
